module.exports = __webpack_public_path__ + "static/media/job_category_6.122738a6.png";